export class Preference {
    public preferenceId: number;
    public prefType: string;
    public dataTableId: string;
    public configuration: any;
}
